import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FrameIn } from 'projects/shared/src/interfaces/frame-in.interface';
import { FrameOutResponse } from 'projects/shared/src/interfaces/frame-out-response.interface';
import { Observable } from 'rxjs';
import { ShHeadersService } from '../headers/sh-headers.service';

@Injectable({
  providedIn: 'root',
})
export class ShFlowTranckigService {
  constructor(
    private http: HttpClient,
    private _shSharedHeaders: ShHeadersService
  ) {}

  shGetFlowTracking(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    return this.http.get<FrameOutResponse>(`${url}`, {
      headers: this._shSharedHeaders.buildHeaders(request, envHeaders),
    });
  }
}
